import React from "react";
import round from "lodash/round";
import startsWith from "lodash/startsWith";

import { getTotal, getDivisionDoc } from "util/lifterHelper";
import { Column } from "components/table/Table";
import { LifterDivision, Meet } from "types";
import maxBy from "lodash/maxBy";
import size from "lodash/size";

const ScoreCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties & { fontSize: number };
}) => {
  const lifter = data;
  if (lifter.row === "header") {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    const mostLiftsLifterDivision = maxBy(
      data.divisions,
      (lifterDivision: LifterDivision) => {
        const division = getDivisionDoc(lifterDivision.divisionId, meet);
        return size(division?.lifts);
      }
    );

    if (!mostLiftsLifterDivision) {
      return null;
    }

    const division = getDivisionDoc(mostLiftsLifterDivision.divisionId, meet);

    if (!division) {
      return null;
    }

    return (
      <div style={style} className="table-cell-inner">
        {round(
          getTotal({
            lifter,
            division,
            meet,
            forecasted: startsWith(column.key, "forecasted"),
          }),
          3
        )}
      </div>
    );
  }
};

export default ScoreCell;
